import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCouponsStoreByIdAction,
  getEndUserAction,
  getStoreRatingByIdAction,
} from "../../redux/actions";
import CouponsTab from "./CouponsTab";
import OverviewTab from "./OverviewTab";
import CustomLoader from "../UI/CustomLoader";
import { getImageUrl } from "../../utils";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PlaceHolderImg from "../../assets/images/PlaceholderImage.png";
import CustomPagination from "../UI/CustomPagination";
import UpdateDateMacrosInString from "../UI/UpdateDateMacrosInString";
import { Badge, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/store.css";
import Macro from "../../utils/ReplaceMacro";
import { Rating } from "react-simple-star-rating";
import Banner from "./Banners";
import { Helmet } from "react-helmet";
import { BiFilterAlt } from "react-icons/bi";
import { BASE_URL } from "../../services/axiosInstance";

const Store = ({ match, history }) => {
  const readRef = useRef();
  const dispatch = useDispatch();

  const { domainData } = useSelector((state) => state.Website);

  const { getEndUser } = useSelector((state) => state.Coupon);

  const itemsPerPage = 15;

  const [selectedTab, setSelectedTab] = useState("Coupons"); // Overview | coupons
  const [incomingSlug, setIncomingSlug] = useState(match?.params?.storeSlug);
  const [shareOfferLink, setShareOfferLink] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [rating, setRating] = useState(0);
  const [randomN, setRandomN] = useState(876);
  // const [filterBy, setFilterBy] = useState("Active");

  const handleRating = (rate) => {
    setRating(rate);
    setRandomN((r) => r + 1);
  };
  const onPointerEnter = () => console.log("Enter");
  const onPointerLeave = () => console.log("Leave");
  const onPointerMove = (value, index) => console.log(value, index);

  const {
    storesList,
    totalRecords,
    totalPages,
    topRatedStores,
    StoreCouponList,
    selectedStore,
    loading,
  } = useSelector((state) => state.Stores);

  let activeStoresList = storesList?.filter(
    (ele) => ele.is_archived === false && ele.is_paused === false
  );

  // const handleFilterChange = (event) => {
  //   setFilterBy(event.target.value); // Update the state with the selected filter value
  // };

  useEffect(() => {
    dispatch(getEndUserAction());
  }, [dispatch]);

  useEffect(() => {
    setLastPage(totalPages);
  }, [totalPages]);

  useEffect(() => {
    setRandomN(Math.floor(Math.random() * 1000 + 1));
  }, []);
  useEffect(() => {
    if (incomingSlug && storesList.length > 0) {
      const store = storesList?.filter(
        (store) => store?.slug === incomingSlug
      )[0];
      let payload = {
        storeId: store?._id,
        perPage: itemsPerPage,
        currentPage: currentPage,
        resolution: `${window.screen.width}x${window.screen.height}`,
        // filterBy: filterBy,
      };
      dispatch(getCouponsStoreByIdAction(payload));
      dispatch(getStoreRatingByIdAction(store?._id));
    }
    // }
  }, [
    currentPage,
    dispatch,
    incomingSlug,
    storesList,
    StoreCouponList,
  ]);

  useEffect(() => {
    setIncomingSlug(match?.params?.storeSlug);
  }, [match]);

  // useEffect(() => {
  //   dispatch(getAllCategoryAction());
  // }, [dispatch]);

  const handlePageChange = (pg) => {
    const store = activeStoresList?.filter(
      (store) => store?.slug === incomingSlug
    )[0];
    window.scrollTo(0, 0);
    setCurrentPage(pg);
    dispatch(
      getCouponsStoreByIdAction({
        perPage: itemsPerPage,
        currentPage: pg,
        storeId: store._id,
      })
    );
  };
  const addDefaultSrc = (e) => {
    e.target.src = PlaceHolderImg;
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Helmet>
      <title>{(selectedStore && selectedStore.slug ? selectedStore.slug + " - " : "") + (domainData && domainData.name ? domainData.name : "")}</title>

      </Helmet>
      <section id="inner-page" className="container">
        {loading ? (
          <CustomLoader />
        ) : selectedStore?.v2_store?.[0]?.is_paused ? (
          <>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Page not found
            </p>
          </>
        ) : (
          <>
            <div className="row">
              <div className="col-sm-12">
                <div className="coupon-head" style={{ position: "relative" }}>
                  <div className="row  ">
                    <div
                      className="col-sm-12 col-md-3 "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <a
                          href={selectedStore?.domain_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={getImageUrl(
                              selectedStore?.image,
                              PlaceHolderImg
                            )}
                            alt=""
                            style={{
                              height: "110px",
                              width: "200px",
                              objectFit: "contain",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
                            }}
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-9 storeHeader">
                      <h3>
                        {" "}
                        <UpdateDateMacrosInString input={selectedStore?.name} />
                      </h3>

                      {selectedStore?.totalRecords && (
                        <Badge
                          bg="inf"
                          style={{
                            fontSize: ".8rem",
                            marginRight: "3px",
                            backgroundColor: domainData
                              ? domainData.header_color
                              : "#fff",
                            color: "white",
                          }}
                        >
                          {selectedStore?.totalRecords ? "Total coupons :" : ""}{" "}
                          {selectedStore?.totalRecords}
                        </Badge>
                      )}
                    </div>
                  </div>
                  <div id="rating-div">
                    <FontAwesomeIcon
                      style={{ color: "gold", fontSize: "3rem" }}
                      icon={faStar}
                    />
                    <p
                      style={{
                        display: "inline",
                        color: "black",
                        fontWeight: "350",
                      }}
                    >
                      &nbsp; <span style={{ fontSize: "3rem" }}>4</span>
                      <span style={{ fontSize: "1.5rem" }}> /5</span>
                      <p
                        style={{
                          fontSize: ".6rem",
                          textAlign: "right",
                          paddingTop: "6%",
                        }}
                      >
                        {" "}
                        <strong
                          style={{
                            fontSize: ".7rem",
                            borderRadius: "10px",
                            border: `1px solid ${
                              domainData?.header_color
                                ? domainData?.header_color
                                : "fff"
                            }`,
                            color: `1px solid ${
                              domainData?.header_color
                                ? domainData?.header_color
                                : "fff"
                            }`,
                            padding: "2px",
                            marginRight: "3px",
                          }}
                        >
                          {randomN} votes
                        </strong>
                        <Badge
                          onClick={handleShow}
                          bg="inf"
                          data-backdrop="false"
                          style={{
                            fontSize: ".8rem",
                            padding: "4px",
                            backgroundColor: domainData?.header_color
                              ? domainData?.header_color
                              : "fff",
                            color: "white",
                            float: "right",
                            marginLeft: "2px",
                            cursor: "pointer",
                          }}
                        >
                          {rating > 0 ? `Rated ${rating}/5` : "Rate this"}
                        </Badge>
                      </p>
                    </p>
                    <Modal show={show} backdrop={true} onHide={handleClose}>
                      <Modal.Header closeButton style={{ fontSize: "1rem" }}>
                        <Modal.Title style={{ textAlign: "center" }}>
                          Rate {selectedStore?.name}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body
                        style={{ padding: "3% 10% 3% 32%", fontSize: "3rem" }}
                      >
                        <Rating
                          onClick={handleRating}
                          onPointerEnter={onPointerEnter}
                          onPointerLeave={onPointerLeave}
                          onPointerMove={onPointerMove}
                        />
                      </Modal.Body>
                      <Modal.Footer style={{ color: "black" }}>
                        <div style={{ textAlign: "center" }}>
                          {rating > 0
                            ? "Thanks for Rating."
                            : `Rated 4/5, out of ${randomN} votes.`}
                        </div>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mTop-20 mobrev">
              <div className="col-sm-12 col-md-3">
                <strong>Popular Stores</strong>
                <div
                  className="mTop-10 widget-inner"
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#f3f3f3",
                    color: "black",
                    padding: "10px",
                  }}
                >
                  <Row>
                    {activeStoresList.slice(0, 6).map((data, key) => (
                      <div
                        className="col-xs-6 "
                        style={{ height: "130px", marginBottom: "10px" }}
                        key={key}
                      >
                        <div
                          className="popularStore"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <Link to={`/store/${data.slug}`}>
                            <img
                              data-tip={data.slug}
                              src={getImageUrl(data?.image, PlaceHolderImg)}
                              alt={data.name}
                              style={{
                                height: "90px",
                                width: "90px",
                                objectFit: "contain",
                                padding: "3px",
                                marginBottom: "3px",
                              }}
                            />
                          </Link>
                          <Link
                            to={`/store/${data.slug}`}
                            className="popularStore"
                          >
                            <UpdateDateMacrosInString
                              input={
                                data?.name.length > 15
                                  ? data?.name.substring(0, 10) + "..."
                                  : data?.name
                              }
                            />
                          </Link>
                        </div>
                        {/* <ReactTooltip backgroundColor="transparent" /> */}
                      </div>
                    ))}
                  </Row>
                </div>
                {selectedStore?.long_description && (
                  <>
                    <br />
                    <strong>About Store</strong>
                    <div
                      className="mTop-10 widget-inner"
                      style={{
                        marginTop: "10px",
                        backgroundColor: "#fff",
                        padding: "10px",
                      }}
                    >
                      <Row>
                        {selectedStore?.long_description && (
                          <div
                            className="col-xs-12 "
                            style={{ marginBottom: "10px" }}
                          >
                            <p
                              style={{
                                color: "black",
                                width: "100%",
                                margin: "0",
                                padding: "0",
                              }}
                            >
                              <Macro input={selectedStore?.long_description} />
                            </p>
                          </div>
                        )}
                      </Row>
                    </div>
                  </>
                )}
                <br />
                <strong>Most Trending Stores</strong>
                <div
                  style={{
                    backgroundColor: "white",
                    padding: "0 6%",
                    marginTop: "4%",
                  }}
                >
                  {topRatedStores?.map((store, index) => (
                    <Link to={`/store/${store?.store_details?.slug}`}>
                      <div
                        style={{ marginBottom: "3%" }}
                        className="d-flex mb-2"
                        key={index}
                      >
                        <img
                          onError={(e) => addDefaultSrc(e)}
                          src={`${BASE_URL}/${store?.store_details?.image}`}
                          height="60"
                          width="85"
                          alt=""
                        />
                        <p
                          style={{
                            color: "black",
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            paddingTop: "7%",
                          }}
                          className="mx-3"
                        >
                          {store?.store_details?.slug}{" "}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
                <div
                  className="w-100 my-2 popularStore"
                  style={{ padding: "4% 2% 0 2%", backgroundColor: "white" }}
                >
                  <Banner getEndUser={getEndUser} />
                </div>
              </div>
              <div className="col-sm-12 col-md-9 col-lg-9" ref={readRef}>
                <div className="widget-inner bg-white shadow mBtm-20">
                  <div
                    role="tabpanel"
                    id="tabs"
                    className="tabbable responsive"
                    style={{ paddingTop: "0px" }}
                  >
                    {/* <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        color: "black",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ fontSize: "16px" }} class="mx-2 m-auto">
                        {" "}
                        <BiFilterAlt /> Status:{" "}
                      </span>
                      <div
                        style={{
                          width: "100px",
                          borderRadius: "10px",
                          backgroundColor: "#ffffff",
                        }}
                        className="dropdown"
                      >
                        <select
                          id="dropdown-button"
                          className="form-control btn-sm form-control-sm"
                          style={{
                            backgroundColor: "#ffffff",
                            border: "1px solid #ced4da",
                            borderRadius: "10px",
                            color: "#495057",
                            // marginBottom: "10px",
                            height: "32px",
                          }}
                          value={filterBy}
                          onChange={handleFilterChange}
                        >
                          <option value="Active">Active</option>
                          <option value="Expired">Expired</option>
                          <option value="All">All</option>
                        </select>
                      </div>
                    </div> */}

                    <ul className="nav nav-tabs" role="tablist">
                      <li
                        role="presentation"
                        className={selectedTab === "Coupons" ? "active" : ""}
                      >
                        <a
                          href="#reviews"
                          aria-controls="reviews"
                          role="tab"
                          data-toggle="tab"
                          onClick={(e) => {
                            e.preventDefault();
                            setSelectedTab("Coupons");
                          }}
                        >
                          Offers
                        </a>
                      </li>
                      <li
                        role="presentation"
                        className={selectedTab === "Overview" ? "active" : ""}
                      >
                        <a
                          href="#tab-1"
                          aria-controls="home"
                          role="tab"
                          data-toggle="tab"
                          onClick={(e) => {
                            e.preventDefault();
                            setSelectedTab("Overview");
                          }}
                        >
                          Overview
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div
                        role="tabpanel"
                        className="tab-pane active"
                        id="home"
                      >
                        <div className="tab-content">
                          {selectedTab === "Overview" ? (
                            <OverviewTab selectedStore={selectedStore} />
                          ) : (
                            <CouponsTab
                              coupons={selectedStore?.coupons}
                              selectedStore={selectedStore}
                              history={history}
                              match={match}
                              setShareOfferLink={setShareOfferLink}
                              shareOfferLink={shareOfferLink}
                              StoreCouponList={StoreCouponList}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CustomPagination
              lastPage={lastPage}
              currentPage={currentPage}
              onClick={handlePageChange}
              entries={totalRecords}
              limit={itemsPerPage}
            />
          </>
        )}
      </section>
    </div>
  );
};

export default Store;
